import { render } from "./SzCardLayout.vue?vue&type=template&id=f9a763d2&scoped=true"
import script from "./SzCardLayout.vue?vue&type=script&lang=js"
export * from "./SzCardLayout.vue?vue&type=script&lang=js"

import "./SzCardLayout.vue?vue&type=style&index=0&id=f9a763d2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-f9a763d2"

export default script